<template>
  <div
    class="authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4"
    :style="`background-image: url('${baseUrl}vendor/img/bg/1.jpg');`"
  >
    <div class="ui-bg-overlay bg-dark opacity-25"></div>

    <div class="login-card">
      <g-loading>
        <b-card no-body>
          <div class="p-4 p-sm-5">
            <div class="d-flex justify-content-center align-items-center pb-2 mb-4">
              <div class="ui-w-60">
                <div class="w-100 position-relative" style="padding-bottom: 54%">
                  <appDefaultLogo2 v-if="!logoIcon" />
                  <span v-else>
                    <b-img class="logo-app-custom-login" :src="logoIcon" />
                  </span>
                </div>
              </div>
            </div>

            <h4 class="text-center text-muted font-weight-normal mb-4 mt-5">{{ appName }}</h4>

            <div>
              <h5 v-if="secretKey" class="text-center text-muted font-weight-normal mb-4 mt-5">
                {{ $t('Para ler o QR code use o Google Authenticator') }}:
                <a :href="linkPlay" @click.prevent="openNewTab(linkPlay)">Google Play Store</a> {{ $t('ou') }}
                <a :href="linkPlay" @click.prevent="openNewTab(linkPlay)">App Store</a>.
              </h5>
              <!-- qr code para cadastrar a secret -->
              <div v-if="secretKey" class="d-flex justify-content-center align-items-center pb-2 mb-4">
                <qrcode-vue :value="secretKey" :size="200" level="H"></qrcode-vue>
              </div>
              <div v-if="secretKey" class="d-flex justify-content-center align-items-center pb-2 mb-4">
                <b-button-group size="sm" class="btn-group">
                  <b-button variant="primary" @click.prevent="openNewTab(linkPlay)" v-b-tooltip.hover>
                    <font-awesome-icon :icon="['fas', 'play']" />
                  </b-button>

                  <b-button variant="primary" @click.prevent="openNewTab(linkApp, '_blank')" v-b-tooltip.hover>
                    <font-awesome-icon :icon="['fass', 'apple-whole']" />
                  </b-button>
                  <b-button variant="primary" @click.prevent="copySecret()" v-b-tooltip.hover>
                    <font-awesome-icon :icon="['fas', 'copy']" />
                  </b-button>
                </b-button-group>
              </div>
              <b-row v-if="secretKey">
                <b-col>
                  <small>
                    {{ $t('Assegure-se de que o QR code tenha sido lido com sucesso antes de prosseguir.') }}
                  </small>
                </b-col>
              </b-row>
              <b-row v-if="secretKey && counter" class="text-center mt-3">
                <b-col>
                  <h5>
                    {{ counter }}
                  </h5>
                </b-col>
              </b-row>
              <b-form-group v-if="showLoginFields" :label="$t('Usuário')">
                <b-input type="email" v-model="auth.email" required="required" @keyup.enter="login()" />
              </b-form-group>
              <b-form-group v-if="showLoginFields">
                <div slot="label" class="d-flex justify-content-between align-items-end">
                  <div>{{ $t('Senha') }}</div>
                  <a @click="onForgetPassTap" id="text-link-senha" class="d-block small" v-if="false">{{
                    $t('Esqueceu a senha?')
                  }}</a>
                </div>
                <b-input-group>
                  <b-input
                    :type="show_password ? 'text' : 'password'"
                    required="required"
                    v-model="auth.senha"
                    @keyup.enter="login()"
                  />
                  <b-input-group-prepend is-text @click="show_password = !show_password">
                    <b-icon-eye v-if="!show_password" />
                    <b-icon-eye-slash v-else />
                  </b-input-group-prepend>
                </b-input-group>
              </b-form-group>
              <b-form-group v-if="requireTotp" :label="$t('Código de verificação em duas etapas')">
                <b-input
                  class="totp-pass-input"
                  type="number"
                  v-model="totp"
                  required="required"
                  @keyup.enter="login()"
                />
              </b-form-group>
              <b-form-group>
                <div class="d-flex align-items-center mt-2">
                  <b-btn v-if="!secretKey" variant="primary" block @click="login()" :disabled="loading">
                    <pulse-loader v-show="loading" :size="7.5" color="#fff" />
                    <div v-show="!loading">Login</div></b-btn
                  >
                  <b-btn
                    v-if="secretKey && showConfirm"
                    variant="primary"
                    block
                    @click="confirm()"
                    :disabled="loading"
                  >
                    <pulse-loader v-show="loading" :size="7.5" color="#fff" />
                    <div v-show="!loading">Confirm</div></b-btn
                  >
                </div>
              </b-form-group>
            </div>
          </div>
          <b-card-footer class="py-3 px-4 px-sm-5" v-if="false">
            <div class="text-center text-muted">
              {{ $t('Não possui conta?') }}
              <a @click="onSignUpTap" id="text-link-cadastrar">{{ $t('Cadastrar') }}</a>
            </div>
          </b-card-footer>
        </b-card>
      </g-loading>
    </div>
  </div>
</template>
<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>
<script>
import app from '@/store/modules/app';
import { log } from 'bootstrap-vue-dialog/dist/bootstrap-vue-dialog';
import QrcodeVue from 'qrcode.vue';
import appDefaultLogo2 from '@/components/helpers/appDefaultLogo2';
import http from '@/services/http.service';
import store from '@/store';

export default {
  name: 'pages-authentication-login-v2',
  data() {
    return {
      counter: 10,
      size: 200,
      auth: { email: '', senha: '' },
      show_password: false,
      totp: null,
      showLoginFields: true,
      requireTotp: false,
      secretKey: false,
      showConfirm: false,
      valueSecret: null,
      accessToken: null,
      timeoutReset: null,
      linkPlay:
        'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=pt_BR&gl=US&pli=1',
      linkApp: 'https://apps.apple.com/br/app/google-authenticator/id388497605'
    };
  },
  components: {
    QrcodeVue,
    appDefaultLogo2
  },
  metaInfo: {
    title: 'Login'
  },

  computed: {
    loading() {
      return this.$util.gloading.isLoading();
    },
    appName() {
      let appName = 'Atena';
      return process.env.VUE_APP_TITLE || appName;
    },
    logoIcon() {
      return process.env.VUE_APP_LOGO;
    }
  },

  created() {
    let language = navigator.language;
    this.onAlterarIdioma(language);
  },

  methods: {
    getNomeApp() {
      return (process.env.VUE_APP_TITLE || 'Atena').replaceAll(' ', '');
    },
    async login() {
      if (this.requireTotp) {
        await this.secontStep();
      } else {
        const credentials = {
          email: this.auth.email.trim(),
          senha: String(this.auth.senha).trim()
        };

        try {
          this.$util.gloading.show();
          const response = await this.$auth.loginDirect(credentials);

          if (response.codResposta == 209) {
            this.$util.gloading.hide();
            this.showLoginFields = false;
            this.secretKey = `otpauth://totp/${this.getNomeApp()}?secret=${response.secretKey}`;
            this.valueSecret = response.secretKey;
            this.timeoutReset = setTimeout(() => this.reset(), 300000);
          } else if (response.codResposta == 210) {
            this.$util.gloading.hide();
            this.showLoginFields = false;
            this.requireTotp = true;
            this.timeoutReset = setTimeout(() => this.reset(), 300000);
          } else if (response.codResposta == '000') {
            await store.dispatch('auth/registerLogin', response);
            const sessionData = await http.post('/api/common/session/addon', response);
            await store.dispatch('user/registerUserSessionData', sessionData);

            this.auth.email = '';
            this.auth.senha = '';
            this.totp = null;
            localStorage.removeItem('mfa-accomplished');
            this.$util.gloading.hide();

            await this.$router.push('/dashboard');
            this.loggedMessage();
          } else {
            this.$util.gloading.hide();
          }
        } catch (err) {
          this.$util.gloading.hide();
          this.alertMessage(err);
        }
      }
    },
    async secontStep() {
      if (!this.totp) {
        this.alertMessage();
        return;
      }
      const credentials = {
        email: this.auth.email.trim(),
        senha: String(this.auth.senha).trim(),
        totp: this.totp
      };

      try {
        this.$util.gloading.show();
        const response = await this.$auth.loginDirect(credentials);

        if (response.codResposta == '000') {
          await store.dispatch('auth/registerLogin', response);
          const sessionData = await http.post('/api/common/session/addon', response);
          await store.dispatch('user/registerUserSessionData', sessionData);

          this.auth.email = '';
          this.auth.senha = '';
          this.totp = null;
          this.secretKey = false;
          this.valueSecret = null;
          localStorage.setItem('mfa-accomplished', 'yes');
          clearTimeout(this.timeoutReset);
          this.$util.gloading.hide();

          await this.$router.push('/dashboard');
          this.loggedMessage();
        } else {
          this.$util.gloading.hide();
          this.alertMessage({ mensagem: response.mensagem || 'Erro ao autenticar' });
        }
      } catch (err) {
        this.$util.gloading.hide();
        this.alertMessage(err);
      }
    },
    confirm() {
      this.requireTotp = true;
      this.secretKey = false;
      this.valueSecret = null;
    },

    alertMessage(err) {
      this.$notify({
        type: 'error',
        title: 'Erro ao Autenticar',
        text: err?.message || err?.mensagem || 'Erro ao Autenticar'
      });
    },
    reset() {
      this.$util.formWarn({
        msgTitle: 'Expirado',
        msgContent: 'Chave expirada, faça o processo de login novamente.',
        type: 'error'
      });
      this.auth.email = '';
      this.auth.senha = '';
      this.totp = null;
      this.showLoginFields = true;
      this.requireTotp = false;
      this.secretKey = false;
      this.valueSecret = null;
      this.accessToken = null;
    },

    loggedMessage() {
      this.$util.formWarn({
        msgTitle: 'Autenticação Completada',
        msgContent: 'Bem-vindo de volta!',
        type: 'success'
      });
    },

    onForgetPassTap() {
      console.log('esqueci minha senha');
    },

    onSignUpTap() {
      console.log('cadastrar');
    },

    onAlterarIdioma(idioma) {
      this.$i18n.locale = idioma;
      this.$store.dispatch('auth/registerTrocarIdioma', idioma);
    },
    copySecret() {
      this.$util.copyToClipBoard(this.valueSecret, (success) => {
        if (success) {
          this.$util.formWarn({
            msgTitle: 'Sucesso',
            msgContent: 'Copiado com sucesso',
            type: 'success'
          });
        } else {
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: 'Erro ao copiar',
            type: 'error'
          });
        }
      });
    },
    openNewTab(arg) {
      window.open(arg, '_blank');
    }
  },

  watch: {
    // Focar no input de verificação de segunda etapa
    requireTotp(req) {
      if (req === true) {
        let totp_input = document.getElementsByClassName('totp-pass-input');

        this.$nextTick(() => {
          totp_input[0].focus();
        });
      }
    },
    secretKey(v) {
      if (v) {
        clearTimeout(window.qrcode_timout_show);
        clearInterval(window.qrcode_timout_counter);

        window.qrcode_timout_show = setTimeout(() => {
          this.showConfirm = true;
        }, 10000);

        window.qrcode_timout_counter = setInterval(() => {
          if (this.counter > 0) {
            this.counter--;
          }
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#text-link-cadastrar {
  color: #3c8ae2;
}

#text-link-cadastrar:hover {
  text-decoration: underline;
  cursor: pointer;
}

#text-link-senha {
  color: #3c8ae2;
}

#text-link-senha:hover {
  text-decoration: underline;
  cursor: pointer;
}

.totp-pass-input {
  font-size: 30px;
  letter-spacing: 15px;
  text-align: center;
}

.login-card {
  max-width: 20.438rem !important;
}
.logo-app-custom-login {
  width: 50px !important;
  height: 50px !important;
  margin-top: 25px;
  margin-bottom: -25px;
}
</style>
